import script from "./SuccessWorkstationCreationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SuccessWorkstationCreationModal.vue?vue&type=script&setup=true&lang=js"

import "./SuccessWorkstationCreationModal.vue?vue&type=style&index=0&id=1e04114c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e04114c"]])

export default __exports__